/* Royal Kronleuchter · Erlebnis „licht“ · Vertrag: erlebnis/VERTRAG.md */
(function () {
'use strict';
var R = window.RKErlebnis = window.RKErlebnis || {};
if (R.licht) return;
var D = document, M = Math, PI = M.PI, rnd = M.random, SPR = null, P = 'rk-licht__', TITEL = 'Die Lichtzeremonie', SEL = 'section.rk-erl[data-typ="licht"]';
var mq = matchMedia('(prefers-reduced-motion: reduce)'), DOE = window.DeviceOrientationEvent, frage = !!(DOE && DOE.requestPermission);

var clamp = (v, a, b) => v < a ? a : v > b ? b : v;
var glatt = (a, b, x) => { var t = clamp((x - a) / (b - a), 0, 1); return t * t * (3 - 2 * t); };
var on = (el, t, f) => el.addEventListener(t, f);
var esc = s => String(s).replace(/[&<>"]/g, c => '&#' + c.charCodeAt(0) + ';');
var tag = (t, c, inner, attr) => `<${t} class="${P}${c}"${attr || ''}>${inner}</${t}>`;
var fern = u => /^(https?:)?\/\//.test(u);
var url = (u, w) => fern(u) ? u + (u.indexOf('?') > -1 ? '&' : '?') + 'width=' + w : u;
var cm = n => String(M.round(n * 10) / 10).replace('.', ',') + ' cm';
var leinwand = s => { var c = D.createElement('canvas'); c.width = c.height = s; return c; };
var an = (n, x, c) => { if (n && n._an !== x) { n._an = x; n.classList.toggle(c || 'is-an', x); } };
var px = n => n + 'px';

function sprites() {
	var a = leinwand(64), x = a.getContext('2d'), b = leinwand(96), y = b.getContext('2d'), g = x.createRadialGradient(32, 32, 0, 32, 32, 32), i;
	[[0, '255,251,242,1'], [.14, '255,240,210,.75'], [.36, '255,232,196,.16'], [1, '255,232,196,0']].forEach(s => g.addColorStop(s[0], 'rgba(' + s[1] + ')'));
	x.fillStyle = g; x.fillRect(0, 0, 64, 64); x.fillRect(31, 0, 2, 64); x.fillRect(0, 31, 64, 2);
	g = y.createRadialGradient(48, 48, 0, 48, 48, 48); g.addColorStop(0, 'rgba(255,246,232,.5)'); g.addColorStop(1, 'hsla(270,100%,75%,0)');
	for (i = 0; i < 5; i++) g.addColorStop(.3 + i * .14, `hsla(${i * 60},85%,76%,${.36 - i * .05})`);
	y.fillStyle = g; y.fillRect(0, 0, 96, 96);
	return [a, b];
}

var VS = 'attribute vec2 p;uniform vec2 uS,uO;varying vec2 v;void main(){v=uO+vec2(p.x*.5+.5,.5-p.y*.5)*uS;gl_Position=vec4(p,0.,1.);}';
var FS = 'precision mediump float;\n#define S smoothstep\nuniform sampler2D tA,tB,tL;uniform float uL,uAus,uN;uniform vec4 uBox;uniform vec2 uC;varying vec2 v;' +
	'const vec3 W=vec3(.2126,.7152,.0722);void main(){' +
	'vec3 a=texture2D(tA,v).rgb;float ls=dot(a,W),lb=dot(texture2D(tL,v).rgb,W),lum=clamp(max(lb*1.12,ls*.92)*uN,0.,1.);' +
	'vec3 o=uAus>.5?texture2D(tB,v).rgb:mix(vec3(ls),a,.4)*.16*vec3(.9,.96,1.12);' +
	'vec2 q=S(uBox.xy-.07,uBox.xy+.01,v)*(1.-S(uBox.zw-.01,uBox.zw+.07,v));float bw=q.x*q.y;' +
	'float e=mix(3.2,.4,lum)+distance(v,uC)*1.5+.6-bw*.9;' +
	'vec3 c=mix(o,a,clamp(pow(uL,e)+S(.88,1.,ls*uN)*S(0.,.14,uL)*bw,0.,1.));' +
	'c+=vec3(1.,.76,.48)*lb*lb*bw*S(.6,1.,uL)*.07;gl_FragColor=vec4(c,1.);}';

/* GL-Enums als Zahlen; Texturen LINEAR + CLAMP_TO_EDGE */
function glBau(cv, bilder) {
	var gl = cv.getContext('webgl', { alpha: false, antialias: false, depth: false, failIfMajorPerformanceCaveat: true }), U = {}, pr, T2 = 3553;
	if (!gl) return null;
	pr = gl.createProgram();
	[[35633, VS], [35632, FS]].forEach(s => { var x = gl.createShader(s[0]); gl.shaderSource(x, s[1]); gl.compileShader(x); gl.attachShader(pr, x); });
	gl.bindAttribLocation(pr, 0, 'p'); gl.linkProgram(pr);
	if (!gl.getProgramParameter(pr, 35714)) return null;
	gl.useProgram(pr); gl.bindBuffer(34962, gl.createBuffer());
	gl.bufferData(34962, new Float32Array([-1, -1, 1, -1, -1, 1, 1, 1]), 35044);
	gl.enableVertexAttribArray(0); gl.vertexAttribPointer(0, 2, 5126, false, 0, 0);
	'tB tL uL uAus uN uBox uC uS uO'.split(' ').forEach(n => { U[n] = gl.getUniformLocation(pr, n); });
	try {
		bilder.forEach((b, i) => {
			if (!b) return;
			gl.activeTexture(33984 + i); gl.bindTexture(T2, gl.createTexture());
			[10240, 10241, 10242, 10243].forEach(k => gl.texParameteri(T2, k, k > 10241 ? 33071 : 9729));
			gl.texImage2D(T2, 0, 6407, 6407, 5121, b);
		});
	} catch (e) { return null; }
	return { gl, U, cv };
}

function starte(sec) {
var d, wrap = sec.querySelector('.rk-licht');
if (sec.dataset.rkInit || !wrap) return;
sec.dataset.rkInit = '1';
try { d = JSON.parse(sec.querySelector('.rk-erl__daten').textContent); } catch (e) { /* fehlt oder ungültig */ }
if (!d || typeof d.bild_an !== 'string' || !d.bild_an) return;

var ruhig = mq.matches, m = sec.dataset.rkSizeUnverified === 'true' ? {} : d.masse || {}, ml = [], box = [].concat(d.box || []).map(x => clamp(+x || 0, 0, 1));
if (!(box[2] > box[0] && box[3] > box[1])) box = [.2, .05, .8, .6];
if (+m.breite_cm > 0) ml.push('Ø ' + cm(m.breite_cm));
if (+m.hoehe_cm > 0) ml.push('Höhe ' + cm(m.hoehe_cm));
var bcx = (box[0] + box[2]) / 2, bcy = (box[1] + box[3]) / 2, lcy = box[1] + (box[3] - box[1]) * .62;
var name = String(d.name || '').trim(), en = esc(name), ah = ' aria-hidden="true"';
var zt = [].concat(d.zeilen || []).map(z => String(z || '').trim()).filter(z => z && !(ml.length && /^Ø/.test(z)) && !(sec.dataset.rkSizeUnverified === 'true' && /Ø|Höhe/.test(z))).slice(0, 4);
wrap.className += ruhig ? ' is-js is-ruhig' : ' is-js';

var text = tag('div', 'text', zt.map(z => tag('p', 'zeile', esc(z))).join('') +
	tag('div', 'ende', (name ? tag('p', 'ende-name', en, ah) : '') + (ml.length ? tag('p', 'masse', ml.join(' · ')) : '') +
		tag('a', 'link', `Ausführung wählen <span${ah}>↑</span>`, ' href="#MainProduct"')));
var dimmer = ruhig ? '' : tag('div', 'dimmer', `<svg class="${P}skala" viewBox="0 0 150 96"${ah}>` +
	`<path class="${P}striche" d="M22.5 75a52.5 52.5 0 0 1 105 0" pathLength="100.6"/><path class="${P}striche ${P}haupt" d="M20.5 75a54.5 54.5 0 0 1 109 0" pathLength="100.8"/>` +
	`<path class="${P}bogen" d="M29 75a46 46 0 0 1 92 0" pathLength="100"/></svg>` + tag('p', 'hinweis', 'Dimmer drehen oder weiterscrollen') +
	tag('div', 'knopf', tag('span', 'dreh', '<i></i>'), ' role="slider" tabindex="0" aria-label="Helligkeit" aria-valuemin="0" aria-valuemax="100"'));
wrap.insertAdjacentHTML('beforeend', tag('div', 'buehne', tag('div', 'bild', '', ah) + (ruhig ? '' : tag('canvas', 'funken', '', ah)) +
	tag('div', 'kopf', tag('p', 'label', TITEL) + (name ? tag('h2', 'name', en) : '')) + text + dimmer, ` role="group" aria-label="${TITEL}"`));
var $ = c => wrap.querySelector('.' + P + c);
var buehne = $('buehne'), bild = $('bild'), fx = $('funken'), kopf = $('kopf'), txt = $('text'), hinweis = $('hinweis'), ende = $('ende'), dim = $('dimmer'), knopf = $('knopf');
var zeilen = wrap.querySelectorAll('.' + P + 'zeile'), starts = zt.map((z, i) => .3 + i * M.min(.25, .5 / M.max(1, zt.length - 1)));
on($('link'), 'click', e => {
	var z = D.querySelector('#MainProduct,[id^="ProductOptions-"]'), b = { top: 0, behavior: ruhig ? 'auto' : 'smooth' };
	e.preventDefault();
	z ? z.scrollIntoView(b) : scrollTo(b);
});

var lv = ruhig ? 1 : 0, dimW = 0, man = false, sicht = false, geladen = false, gefragt = false, norm = 1, kw = -1, kp = -1, stTop = 0, sp = 0, fd = 0, fk = false;
var W = 1, H = 1, dw = 1, dh = 1, ox = 0, oy = 0, iw = 1254, ih = 1254, dpr = 1, G = null, fb = null, raf = 0, zuletzt = 0, gez = -1, zug = null, basisB = null, leer = true;
var ctx = fx && fx.getContext('2d'), kand = [], funken = [], prismen = [], nx = 0, ny = 0, zx = 0, zy = 0;

/* box frei: über Text + Dimmer, flach quer zwischen Spalten sp */
function vermessen() {
	W = bild.clientWidth || 1; H = bild.clientHeight || 1;
	dpr = M.min(devicePixelRatio || 1, 2);
	var cs = M.max(W / iw, H / ih), bw = (box[2] - box[0]) * iw, bh = (box[3] - box[1]) * ih, y1 = H - 16, rb = 0, cl = wrap.classList, s, fh, k;
	sp = 0;
	if (!ruhig) {
		stTop = parseFloat(getComputedStyle(buehne).top) || 0;
		cl.remove('is-seite'); rb = H - txt.offsetTop; y1 = H - rb - 40;
		if (W > H * 1.2 && bh * cs > y1 - 16) { sp = clamp(W * .26, 190, 360); y1 = dim.offsetTop + 114; cl.add('is-seite'); }
	}
	s = M.max(cs * .5, M.min(cs, (y1 - 16) * .94 / bh, sp ? (W - 2 * sp) * .94 / bw : cs));
	dw = iw * s; dh = ih * s;
	ox = clamp(W / 2 - bcx * dw, M.min(0, W - dw), M.max(0, W - dw));
	oy = clamp((16 + y1) / 2 - bcy * dh, M.min(0, H - dh), M.max(0, H - dh));
	k = [ox > .5 ? ox : -99, oy > .5 ? oy : -99, ox + dw < W - .5 ? ox + dw : W + 99, oy + dh < H - .5 ? oy + dh : H + 99];
	bild.classList.toggle('is-rand', k[0] > 0 || k[1] > 0 || k[2] < W || k[3] < H);
	[ox, oy, dw, dh, bcx * dw, lcy * dh, rb, sp].concat(k).forEach((v, i) => buehne.style.setProperty('--' + 'ox oy dw dh mx my rk-rb rk-spalte e0 e1 e2 e3'.split(' ')[i], px(v)));
	if (G) {
		k = M.min(dpr, M.max(1, iw / dw));
		G.gl.viewport(0, 0, G.cv.width = M.round(W * k), G.cv.height = M.round(H * k)); G.gl.uniform2f(G.U.uS, W / dw, H / dh); G.gl.uniform2f(G.U.uO, -ox / dw, -oy / dh);
	}
	if (fx) { fh = M.min(H, M.max(H * .6 + 60, oy + box[3] * dh + 24)); fx.style.height = px(fh); fx.width = M.round(W * dpr); fx.height = M.round(fh * dpr); leer = true; prismenBauen(); }
	gez = -1; zeichnen();
}

function zeichnen() {
	if (M.abs(lv - gez) < 2e-4) return;
	gez = lv;
	var L = clamp((lv - .08) / .92, 0, 1);
	if (G) { G.gl.uniform1f(G.U.uL, L); G.gl.drawArrays(5, 0, 4); } else if (fb && !ruhig) {
		fb.style.opacity = L; fb.style.setProperty('--r', px((.04 + 1.5 * M.pow(L, 1.3)) * M.max(W, H)));
	}
}

function texte() {
	var i = -1, j, n = zeilen.length, v = man ? dimW : lv, p = M.round(v * 100), k = lv < .04;
	if (lv >= .95) i = n; else for (j = 0; j < n; j++) if (lv >= starts[j]) i = j;
	for (j = 0; j < n; j++) an(zeilen[j], i === j);
	an(ende, i === n); an(kopf, k); an(buehne, k, 'is-kopf'); an(hinweis, k && !man);
	if (!dim || M.abs(v - kw) < 1e-3) return;
	kw = v; dim.style.setProperty('--v', v.toFixed(4));
	if (p !== kp) { kp = p; knopf.setAttribute('aria-valuenow', p); knopf.setAttribute('aria-valuetext', 'Helligkeit ' + p + ' %'); }
}

function prismenBauen() {
	prismen = [];
	var xa = M.max(sp, ox), xb = M.min(W - sp, ox + dw), ya = M.max(0, oy), yb = M.min(H, oy + dh);
	for (var i = 0, n = 6 + M.floor(rnd() * 5), k, u = 0, v = 0, drin; i < n; i++) {
		for (k = 0, drin = true; k < 40 && drin; k++) {
			u = (xa + (xb - xa) * (.06 + .88 * rnd()) - ox) / dw; v = (ya + (yb - ya) * (.08 + .52 * rnd()) - oy) / dh;
			drin = u > box[0] - .02 && u < box[2] + .02 && v > box[1] && v < box[3] + .02 && (v - box[1]) / (box[3] - box[1]) > .22;
		}
		if (!drin) prismen.push({ u, v, r: 8 + 14 * rnd(), d: .5 + .5 * rnd(), ph: 6.283 * rnd(), per: 9 + 7 * rnd(), amp: 5 + 9 * rnd(), rot: PI * rnd(), a: .2 + .15 * rnd() });
	}
}

function funkeln(dt, t) {
	if (!ctx) return;
	var soll = M.round(50 * glatt(.55, 1, lv)), pa = glatt(.55, .95, lv), fa = glatt(.55, .7, lv), s = dpr, i, p, f, x, y, g, e, c, n;
	g = M.min(1, dt * 3.5); nx += (zx - nx) * g; ny += (zy - ny) * g;
	if (!soll && !funken.length && pa <= 0) { if (!leer) { ctx.clearRect(0, 0, fx.width, fx.height); leer = true; } return; }
	leer = false; SPR = SPR || sprites();
	ctx.clearRect(0, 0, fx.width, fx.height); ctx.globalCompositeOperation = 'lighter';
	for (i = 0; i < prismen.length; i++) {
		p = prismen[i]; c = M.cos(p.rot); n = M.sin(p.rot); g = p.r * s;
		x = (ox + p.u * dw + M.cos(t * 6.283 / p.per + p.ph) * p.amp + nx * p.d) * s;
		y = (oy + p.v * dh + M.sin(t * 4.833 / p.per + p.ph) * p.amp * .6 + ny * p.d) * s;
		ctx.globalAlpha = pa * p.a * (.8 + .2 * M.sin(t * .9 + p.ph));
		ctx.setTransform(c * 2.4, n * 2.4, -n, c, x, y); ctx.drawImage(SPR[1], -g, -g, 2 * g, 2 * g);
	}
	ctx.setTransform(1, 0, 0, 1, 0, 0);
	for (i = 0; i < 2 && funken.length < soll && kand.length; i++) {
		c = kand[(rnd() * kand.length) | 0];
		funken.push({ u: c[0] + (rnd() - .5) / 256, v: c[1] + (rnd() - .5) / 256, g: 3 + 6 * rnd() * rnd(), l: .8 + .8 * rnd(), a: 0 });
	}
	for (i = funken.length - 1; i >= 0; i--) {
		f = funken[i]; f.a += dt; e = f.a / f.l;
		if (e >= 1) { funken.splice(i, 1); continue; }
		e = M.sin(PI * e); g = f.g * 3 * (.6 + .4 * e) * s; ctx.globalAlpha = e * e * fa;
		ctx.drawImage(SPR[0], (ox + f.u * dw) * s - g / 2, (oy + f.v * dh) * s - g / 2, g, g);
	}
}

function takt(now) {
	raf = 0;
	if (!sicht || D.hidden) return;
	var r = wrap.getBoundingClientRect(), dt = zuletzt ? M.min(.05, (now - zuletzt) / 1000) : .016;
	var ziel = man ? dimW : clamp(((stTop - r.top) / M.max(1, r.height - H) - .1) / .7, 0, 1);
	zuletzt = now; lv += (ziel - lv) * (1 - M.exp(-dt / (man ? .1 : .16)));
	if (M.abs(ziel - lv) < 1e-3) lv = ziel;
	zeichnen(); texte(); fd += dt;
	if (lv !== ziel || (fk = !fk)) { funkeln(fd, now / 1000); fd = 0; }
	raf = requestAnimationFrame(takt);
}
function wecken() { if (!raf && !ruhig && sicht && !D.hidden) { zuletzt = 0; raf = requestAnimationFrame(takt); } }

function mkBild(u, cls) {
	var im = D.createElement('img');
	im.className = P + 'img ' + P + cls; im.alt = ''; im.decoding = 'async';
	on(im, 'error', () => {
		if (im.crossOrigin) im.removeAttribute('crossorigin');
		else if (u === d.bild_aus) { d.bild_aus = null; im.classList.remove('is-echt'); im.removeAttribute('srcset'); im.src = url(d.bild_an, 1100); }
	});
	if (fern(u)) {
		im.crossOrigin = 'anonymous';
		im.srcset = [480, 750, 1100, 1500].map(w => url(u, w) + ' ' + w + 'w').join(', ');
		im.sizes = '(orientation: portrait) 100vh, 100vw';
	}
	im.src = url(u, 1100);
	return bild.appendChild(im);
}
function analyse(img) {
	try {
		var c = leinwand(256), x = c.getContext('2d'), li = [], i, u, v, l, px, L = j => (px[j] * .2126 + px[j + 1] * .7152 + px[j + 2] * .0722) / 255;
		x.drawImage(img, 0, 0, 256, 256); px = x.getImageData(0, 0, 256, 256).data;
		for (i = 257; i < 65279; i++) {
			u = (i % 256 + .5) / 256; v = ((i >> 8) + .5) / 256; l = L(i * 4);
			if (u > box[0] && u < box[2] && v > box[1] && v < box[3]) li.push([u, v, l, l - (L(i * 4 - 4) + L(i * 4 + 4) + L(i * 4 - 1024) + L(i * 4 + 1024)) / 4]);
		}
		li.sort((a, b) => b[2] - a[2]);
		norm = clamp(1 / M.max(li.length ? li[M.floor(li.length * .005)][2] : 1, .05), 1, 1.6);
		kand = li.filter(a => a[2] * norm > .6 && a[3] > .05);
		if (kand.length < 24) kand = li.slice(0, 40);
		return c;
	} catch (e) { return null; }
}
function glStart(a, b, lum) {
	var cv = bild.appendChild(D.createElement('canvas')), gl, U;
	cv.className = P + 'gl'; G = glBau(cv, [a, b, lum]);
	if (!G) return !!cv.remove();
	gl = G.gl; U = G.U;
	gl.uniform1i(U.tB, b ? 1 : 0); gl.uniform1i(U.tL, 2); gl.uniform1f(U.uAus, b ? 1 : 0); gl.uniform1f(U.uN, norm);
	gl.uniform4f(U.uBox, box[0], box[1], box[2], box[3]); gl.uniform2f(U.uC, bcx, lcy);
	on(cv, 'webglcontextlost', e => { e.preventDefault(); G = null; cv.remove(); vermessen(); });
	return true;
}
function laden() {
	if (geladen) return;
	geladen = true;
	var aus = ruhig ? null : mkBild(d.bild_aus || d.bild_an, 'img--aus' + (d.bild_aus ? ' is-echt' : '')), n = +ruhig;
	fb = mkBild(d.bild_an, 'img--an');
	[aus, fb].forEach(im => im && on(im, 'load', () => {
		if (++n !== 2) return;
		Promise.all([aus, fb].filter(Boolean).map(i => i.decode().catch(() => {}))).then(() => {
			iw = fb.naturalWidth || 1; ih = fb.naturalHeight || 1;
			var lum = !ruhig && analyse(fb);
			if (lum) glStart(fb, d.bild_aus ? aus : null, lum);
			vermessen(); bild.classList.add('is-da');
		});
	}));
}

/* Dimmer: waagrecht ab 6 px, senkrecht scrollt (pan-y) */
function greifen() {
	if (!man) { man = true; dimW = lv; }
	wecken();
}
function erlaube() {
	if (frage && !gefragt) {
		gefragt = true;
		DOE.requestPermission().then(r => { if (r === 'granted') on(window, 'deviceorientation', neigung); }).catch(() => { gefragt = false; });
	}
}
if (knopf) {
	on(knopf, 'pointerdown', e => { if (!e.button) zug = { id: e.pointerId, x: e.clientX }; });
	on(knopf, 'pointermove', e => {
		if (!zug || e.pointerId !== zug.id) return;
		var dx = e.clientX - zug.x;
		if (zug.akt) dimW = clamp(dimW + dx / 160, 0, 1);
		else if (M.abs(dx) < 6) return;
		else { zug.akt = 1; greifen(); knopf.setPointerCapture(e.pointerId); }
		zug.x = e.clientX; wecken();
	});
	on(knopf, 'pointerup', () => { zug = null; erlaube(); });
	/* 0 = Browser scrollt */
	on(knopf, 'pointercancel', () => { zug = 0; });
	on(knopf, 'touchend', () => { if (zug !== 0) erlaube(); });
	on(knopf, 'click', erlaube);
	on(knopf, 'keydown', e => {
		var s = { ArrowRight: 1, ArrowUp: 1, ArrowLeft: -1, ArrowDown: -1, PageUp: 2, PageDown: -2 }[e.key], v;
		if (e.key === 'Home') v = 0; else if (e.key === 'End') v = 1;
		else if (s) v = M.round(((man ? dimW : lv) + s * .05) * 20) / 20; else return;
		e.preventDefault(); greifen(); erlaube(); dimW = clamp(v, 0, 1);
	});
}

function neigung(e) {
	if (e.gamma == null) return;
	if (basisB == null) basisB = e.beta;
	basisB += (e.beta - basisB) * .004;
	zx = clamp(e.gamma / 25, -1, 1) * 24; zy = clamp((e.beta - basisB) / 25, -1, 1) * 24;
}
if (!ruhig) {
	if (DOE && !frage) on(window, 'deviceorientation', neigung);
	on(buehne, 'pointermove', e => {
		if (e.pointerType !== 'mouse') return;
		var r = buehne.getBoundingClientRect();
		zx = clamp(1 - 2 * (e.clientX - r.left) / r.width, -1, 1) * 24; zy = clamp(1 - 2 * (e.clientY - r.top) / r.height, -1, 1) * 24;
	});
}

var io = new IntersectionObserver(es => { if (es.some(e => e.isIntersecting)) { laden(); io.disconnect(); } }, { rootMargin: '150% 0px' });
var io2 = new IntersectionObserver(es => {
	sicht = es[es.length - 1].isIntersecting;
	if (sicht) wecken(); else { man = false; zug = null; }
}), ro = new ResizeObserver(vermessen);
io.observe(wrap); io2.observe(wrap); ro.observe(buehne);
on(D, 'visibilitychange', wecken);
sec._rkLicht = () => {
	sicht = false; [io, io2, ro].forEach(o => o.disconnect());
	D.removeEventListener('visibilitychange', wecken); window.removeEventListener('deviceorientation', neigung);
	if (G) G.gl.getExtension('WEBGL_lose_context').loseContext();
};
vermessen(); texte();
}

var alle = root => (root || D).querySelectorAll(SEL).forEach(starte);
R.licht = { init: alle };
if (D.readyState === 'loading') on(D, 'DOMContentLoaded', () => alle()); else alle();
on(D, 'shopify:section:load', e => alle(e.target));
on(D, 'shopify:section:unload', e => e.target.querySelectorAll(SEL).forEach(s => s._rkLicht && s._rkLicht()));
})();
